import urlToImage from './urlToImage';

export type MaskType = HTMLImageElement | HTMLCanvasElement;

let lastUrl = '';

async function applyMask(
  imageUrl: string,
  maskUrl: string | MaskType,
): Promise<{ url: string; width: number; height: number }> {
  const image = await urlToImage(imageUrl);
  const mask = typeof maskUrl === 'string' ? await urlToImage(maskUrl) : maskUrl;
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext('2d');

  if (ctx) {
    ctx.drawImage(mask, 0, 0, mask.width, mask.height, 0, 0, image.width, image.height);
    ctx.globalCompositeOperation = 'source-in';
    ctx.drawImage(image, 0, 0);
  }

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        return reject('Could not convert canvas to blob');
      }
      URL.revokeObjectURL(lastUrl);
      lastUrl = URL.createObjectURL(blob);

      URL.revokeObjectURL(imageUrl);
      resolve({
        width: canvas.width,
        height: canvas.height,
        url: lastUrl,
      });
    });
  });
}
export default applyMask;
